import {Component, ContentChild, effect, Inject, Input, OnInit, Signal, TemplateRef, ViewEncapsulation} from '@angular/core';
import {Activitecommerciale} from '@models/activitecommerciale.model';
import {ActivatedRoute, Params} from "@angular/router";
import {DOCUMENT, ViewportScroller} from "@angular/common";
import {CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";
import {PointVenteRepository} from "@galec/repositories";
import {PointVente} from "@models/pointVente.model";
import {ClientMasterService} from "@galec/services/global/clientMaster.service";

@Component({
    selector: 'galec-list-concepts',
    templateUrl: './list-concepts.component.html',
    styleUrls: ['./list-concepts.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ListConceptsComponent implements OnInit {

    private _master: Signal<PointVente> = this.clientMasterService._currentMaster;
    public master: PointVente = this._master();

    @Input() activiteCommerciales: Map<string, Activitecommerciale> = new Map<string, Activitecommerciale>();
    @Input() isUserMagasin: boolean;
    @ContentChild(TemplateRef) templateRef: TemplateRef<any>;
    activiteCommercialesArray: Activitecommerciale[] = [];
    activeId = '';
    activeOrdre = null;
    size = 0;

    // elements;

    constructor(
        private readonly activateRoute: ActivatedRoute,
        private readonly viewportScroller: ViewportScroller,
        private readonly pointVenteRepository: PointVenteRepository,
        private readonly clientMasterService: ClientMasterService,
        @Inject(DOCUMENT) document
    ) {
        effect((): void => {
            const master: PointVente = this._master();
            if (master !== undefined) {
                this.master = master;
                this.setActiviteCommerciale();
                this.activateRoute.queryParams.subscribe({
                    next: (params: Params): void => {
                        this.setActiveTabFromUrl(params);
                    }
                });
            }
        });
    }

    ngOnInit(): void {
        this.activateRoute.queryParams.subscribe({
            next: (params: Params): void => {
                this.setActiveTabFromUrl(params);
            }
        });
    }

    setActiveTabFromUrl(params: any) {
        if (params.id) {
            const activiteCommercial = params.id.slice(5, 8);
            const numeroOrdre = params.id.slice(9, params.id.length);
            if (!isNaN(activiteCommercial) && !isNaN(numeroOrdre)) {
                this.activeId = activiteCommercial;
                this.activeOrdre = parseInt(numeroOrdre, 0);
                this.scrollToItem(params.id);
            }
        } else {
            this.activeId = this.activiteCommerciales.values().next().value?.id ?? 0;
            this.activeOrdre = this.activiteCommerciales.has(this.activeId)
                ? this.activiteCommerciales.get(this.activeId).pointventes.values().next().value?.numero_ordre : 0;
        }
    }

    scrollToItem(id: string) {
        const device = window.innerWidth > 1023 ? 'desktop' : 'mobile';
        setTimeout(() => {
            document.getElementById(`${device}-${id}`).scrollIntoView({behavior: "smooth", block: "end"});
        }, 500);
    }

    /**
     * Set active tab.
     * @param idBaseAdherent string     Concept id.
     */
    protected changeTab(id: string): void {
        this.activeId = id;
        this.activeOrdre = this.activiteCommerciales.get(this.activeId).pointventes.values().next().value.numero_ordre;
    }

    changeItem(numero: number, next: boolean) {
        const keys = [...this.activiteCommerciales.get(this.activeId).pointventes.keys()];
        const iterationKey = keys.indexOf(numero) + (next ? 1 : -1);
        const key = keys[iterationKey] ? iterationKey : (next ? 0 : keys.length - 1);
        this.activeOrdre = keys[key];
    }

    drop(event: CdkDragDrop<string[]>): void {
        moveItemInArray(this.activiteCommercialesArray, event.previousIndex, event.currentIndex);
        this.activiteCommercialesArray.forEach((activite, index) => {
            this.activiteCommerciales.get(activite.id).pointventes.forEach((pointVente) => {
                pointVente.activite_ordre = index + 1;
                this.pointVenteRepository.updateActiviteOrdre({
                    id_base_adherent: pointVente.id_base_adherent,
                    activite_ordre: index + 1,
                }).subscribe({
                    error: (error: any): void => {
                        console.error(error);
                    }
                });
            });
        });
    }

    sort = () => 0;

    private initActiviteCommerciale(): void {
        this.activiteCommercialesArray = [];
    }

    private setActiviteCommerciale(): void {
        this.initActiviteCommerciale();
        this.pointVenteRepository.getConceptsWithMasterId(this.master.id_pointvente).subscribe({
            next: (concepts: Map<string, Activitecommerciale>): void => {
                const activiteCommerciales: Activitecommerciale[] = [];
                for (const [key, value] of concepts) {
                    activiteCommerciales.push(value);
                }
                this.activiteCommerciales = concepts;
                this.activiteCommercialesArray = activiteCommerciales;
                this.setActiveTabFromUrl(this.activateRoute.snapshot.queryParams);
            },
            error: (error: any): void => {
                console.error(`Erreur lors de la récupération des concepts : ${error}`);
            }
        });
    }

}
